<template>
  <div class="container">
    <div v-if="!orderbool">
      <h3 class="green subtitle">
        {{ $translate('subtitle_form_model_rifinitura') }}
      </h3>
      <hr />
    </div>
    <div class="columns">
      <div class="column">
        <b-field
          :type="{ 'is-danger': errors.has('riftype') }"
          :message="errors.first('riftype')"
          :label="$translate('riftype') | capitalize"
        >
          <b-select
            v-model="mod.riftype"
            v-validate="{ required: baseRequired }"
            :placeholder="$translate('placeholder_select')"
            :disabled="disabledbool"
            name="riftype"
            @input="changeriftype"
          >
            <option v-for="optio in $rifinitura" :key="optio.key" :value="optio.key">
              {{ $translate(optio.key) | capitalize }}
            </option>
          </b-select>
        </b-field>
        <b-field
          v-if="mod.riftype != null && mod.riftype != 'rifinitura2'"
          :type="{ 'is-danger': errors.has('mountag') }"
          :message="errors.first('mountag')"
          :label="$translate('mountag') | capitalize"
        >
          <b-select
            v-model="mod.mountag"
            v-validate="{ required: baseRequired || !!mod.riftype }"
            :placeholder="$translate('placeholder_select')"
            :disabled="disabledbool"
            name="mountag"
          >
            <option value="total">
              {{ $translate('total') | capitalize }}
            </option>
            <option value="only_plant">
              {{ $translate('only_plant') | capitalize }}
            </option>
            <option v-if="mod.riftype == 'rifinitura1'" value="zepp_around">
              {{ $translate('zepp_around') | capitalize }}
            </option>
          </b-select>
        </b-field>
      </div>

      <div class="column">
        <div v-if="mod.riftype == 'rifinitura0'" class="columns">
          <div class="column">
            <b-field
              :type="{ 'is-danger': errors.has('guardmat') }"
              :label="$translate('guardmat') | capitalize"
              :message="errors.first('guardmat')"
            >
              <b-select
                v-model="mod.guardmat"
                v-validate="{ required: baseRequired || !!mod.riftype }"
                :placeholder="$translate('placeholder_select')"
                :disabled="disabledbool"
                name="guardmat"
                @input="changepell1"
              >
                <option
                  v-for="optio in availableguard"
                  :key="optio.id"
                  :value="optio.id"
                  :label="$translateMaterial(optio)"
                >
                  {{ $translateMaterial(optio) }}
                </option>
              </b-select>
            </b-field>
            <b-field
              v-show="mod.guardmat != null"
              :message="errors.first('guardvar')"
              :type="{ 'is-danger': errors.has('guardvar') }"
              :label="$translate('guardvar') | capitalize"
            >
              <b-select
                v-model="mod.guardvar"
                v-validate="{ required: baseRequired || !!mod.guardmat }"
                :placeholder="$translate('placeholder_select')"
                :disabled="disabledbool"
                name="guardvar"
                @input="changeImage1"
              >
                <template v-for="optio in availableguard">
                  <template v-if="optio.id == mod.guardmat">
                    <option v-for="variant in optio.variants" :key="variant.id" :value="variant.id">
                      {{ $translateMaterialVariant(variant) }}
                    </option>
                  </template>
                </template>
              </b-select>
            </b-field>
          </div>
          <div class="column">
            <img
              :src="image1 == null ? 'https://place-hold.it/100x100' : image1"
              style="max-width: 150px; max-height: 150px"
            />
          </div>
        </div>

        <div v-if="mod.riftype == 'rifinitura1'" class="columns">
          <div class="column">
            <b-field
              :type="{ 'is-danger': errors.has('fascmat') }"
              :label="$translate('fascmat') | capitalize"
              :message="errors.first('fascmat')"
            >
              <b-select
                v-model="mod.fascmat"
                v-validate="{ required: baseRequired || !!mod.riftype }"
                :placeholder="$translate('placeholder_select')"
                :disabled="disabledbool"
                name="fascmat"
                @input="changepell2"
              >
                <option
                  v-for="optio in availablegomm"
                  :key="optio.id"
                  :value="optio.id"
                  :label="$translateMaterial(optio)"
                >
                  {{ $translateMaterial(optio) }}
                </option>
              </b-select>
            </b-field>
            <b-field
              v-show="mod.fascmat != null"
              :message="errors.first('fascvar')"
              :type="{ 'is-danger': errors.has('fascvar') }"
              :label="$translate('fascvar') | capitalize"
            >
              <b-select
                v-model="mod.fascvar"
                v-validate="{ required: baseRequired || !!mod.fascmat }"
                :placeholder="$translate('placeholder_select')"
                :disabled="disabledbool"
                name="fascvar"
                @input="changeImage2"
              >
                <template v-for="optio in availablegomm">
                  <template v-if="optio.id == mod.fascmat">
                    <option v-for="variant in optio.variants" :key="variant.id" :value="variant.id">
                      {{ $translateMaterialVariant(variant) }}
                    </option>
                  </template>
                </template>
              </b-select>
            </b-field>
          </div>
          <div class="column">
            <img
              :src="image2 == null ? 'https://place-hold.it/100x100' : image2"
              style="max-width: 150px; max-height: 150px"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '../../../helpers/mixins/variables/rifinitura'

export default {
  name: 'Rifinitura',
  props: ['orderbool', 'mod', 'availableguard', 'availablegomm', 'disabledbool', 'orderInfoMandatory', 'isOptional'],
  data() {
    return {
      image1: null,
      image2: null,
    }
  },

  inject: ['$validator'],
  computed: {
    baseRequired() {
      return (!!this.mod.custom && !this.mod.from_duna_catalog && !this.isOptional) || !!this.orderInfoMandatory
    },
  },
  watch: {
    mod: function() {
      this.updateAfterload()
    },
  },
  methods: {
    changeriftype() {
      this.mod.guardvar = null
      this.mod.guardmat = null
      this.mod.fascmat = null
      this.mod.fascvar = null
      this.mod.mountag = null
      this.image1 = null
      this.image2 = null
    },
    changepell1() {
      this.mod.guardvar = null
      this.image1 = null
      this.$forceUpdate()
    },
    changepell2() {
      this.mod.fascvar = null
      this.image2 = null
      this.$forceUpdate()
    },
    changeImage1() {
      this.image1 = null
      for (let index in this.availableguard) {
        if (this.availableguard[index].id == this.mod.guardmat) {
          for (let index2 in this.availableguard[index].variants) {
            if (this.availableguard[index].variants[index2].id == this.mod.guardvar) {
              this.image1 = this.availableguard[index].variants[index2].image
            }
          }
        }
      }
      this.$forceUpdate()
    },
    changeImage2() {
      this.image2 = null
      for (let index in this.availablegomm) {
        if (this.availablegomm[index].id == this.mod.fascmat) {
          for (let index2 in this.availablegomm[index].variants) {
            if (this.availablegomm[index].variants[index2].id == this.mod.fascvar) {
              this.image2 = this.availablegomm[index].variants[index2].image
            }
          }
        }
      }
      this.$forceUpdate()
    },

    updateAfterload() {
      this.changeImage1()
      this.changeImage2()
    },
  },
}
</script>
